import { Box } from '@chakra-ui/react'
import SubscriberTable from './components/SubscriberTable'

export default function User () {
  return (
    <Box pt={{ base: '130px', md: '80px', xl: '80px' }}>
      <SubscriberTable />
    </Box>
  )
}
